// extracted by mini-css-extract-plugin
export var header = "_ho-0";